const MainNav = {
  init: () => {
    // get every nav item that has sub-menus
    const parentNavItems = Array.from(
      document.querySelectorAll(".menu-item-has-children")
    );

    // Todo: add event listener for esc key

    // check if any nodes was found
    if (parentNavItems) {
      // set aria-expanded attr
      parentNavItems.map((item) => {
        item.setAttribute("aria-expanded", "false");

        // add listener for toggle
        item.addEventListener("click", function () {
          let expanded = item.getAttribute("aria-expanded") === "true" || false;
          item.setAttribute("aria-expanded", !expanded);
        });
      });
    }

    // get mobile btn nav
    const mobileBtnNav = document.getElementById("main-header__btn-mobile-nav");

    if (mobileBtnNav) {
      // get main nav wrapper
      const mainNav = document.querySelector(".main-header__nav-wrapper");

      // add toggle to mobile btn nav
      if (mainNav) {
        // toggle mobile nav
        mobileBtnNav.addEventListener("click", function () {
          // get aria labels
          const ariaLabelOpen = mobileBtnNav.getAttribute(
            "data-aria-label-open"
          );
          const ariaLabelClosed = mobileBtnNav.getAttribute(
            "data-aria-label-closed"
          );

          // toggle mobile nav btn expanded attr
          let mobileBtnNavExpanded =
            mobileBtnNav.getAttribute("aria-expanded") === "true" || false;
          mobileBtnNav.setAttribute("aria-expanded", !mobileBtnNavExpanded);

          // toggle aria-label
          if (!mobileBtnNavExpanded) {
            mobileBtnNav.setAttribute("aria-label", ariaLabelClosed);
          } else {
            mobileBtnNav.setAttribute("aria-label", ariaLabelOpen);
          }

          // toggle main nav expanded attr
          mainNav.classList.toggle("is-expanded");
        });
      }
    }
  },
};

export default MainNav;
